import { FormatStringByWordLength, DoArraysOverlap, Split, Join } from "../../../shared/scripts/array-functions";

export class ActionItemListingDto {
    Id: number;
    Type: string;
    Status: string;
    SiteName: string;
    DateDue: string;
    IsUrgent: boolean;
    IsCritical: boolean;
    UserNames: string[];

    constructor() { }

    initialize(): void {
    }

    matchesFilter(site: any, status: any, type: any, critical: any, person: any, dueDate: string): boolean {
        // If any filter is undefined or an empty array, return false
        if (!site || site.length === 0) return false;
        if (!status || status.length === 0) return false;
        if (!type || type.length === 0) return false;
        if (!critical || critical.length === 0) return false;
        if (!person || person.length === 0) return false;

        // Site filter
        if (!site.includes(this.SiteName)) return false;
        // Status filter
        if (!status.includes(this.Status)) return false;
        // Type filter
        if (!type.includes(this.Type)) return false;
        // Critical filter
        const criticalLabel = this.IsCritical ? "Critical" : "Not Critical";
        if (!critical.includes(criticalLabel)) return false;
        // Person Responsible filter
        if (!this.UserNames.some(u => person.includes(u))) return false;
        // Due Date filter
        if (dueDate && dueDate != "" && this.DateDue !== dueDate) return false;

        return true;
    }
}

export class MilestoneListingDto {
    Id: number;
    SiteNumber: number;
    SiteName: string;
    MilestoneName: string;
    MilestoneCategory: string;
    MilestoneCategoryAndName: string;
    StartedDate: string;
    ExpectedDueDate: string;
    CompletionDate: string;
    StatusName: string;
    StudyName: string;
    OrderId: number;
    CTMSOperationMilestoneStatusId: number;
    CTMSOperationMilestoneStatusName: string;
    Notes: string;
    NotApplicable: boolean;
    IsStartupEssential: boolean;
    IsChecklistItem: boolean;
    ShowOnPortal: boolean;
    IsDisabled: boolean;

    constructor() { }

    initialize(): void {
    }

    matchesFilter(milestone: any, startedDate: string, expectedDueDate: string, completionDate: string, study: any, isStartupEssential: any, isChecklistItem: any, showOnPortal: any, milestoneStatus: any): boolean {
        // Milestone filter
        if (milestone && milestone.length > 0 && !milestone.includes(this.MilestoneCategoryAndName)) return false;
        // Started Date filter
        if (startedDate && startedDate !== "" && this.StartedDate !== startedDate) return false;
        // Expected Due Date filter
        if (expectedDueDate && expectedDueDate !== "" && this.ExpectedDueDate !== expectedDueDate) return false;
        // Completion Date filter
        if (completionDate && completionDate !== "" && this.CompletionDate !== completionDate) return false;
        // Study filter
        if (study && study.length > 0 && !study.includes(this.StudyName)) return false;
        // Status filter
        let statusName = (this.CTMSOperationMilestoneStatusName && this.CTMSOperationMilestoneStatusName.length > 0)  ? this.CTMSOperationMilestoneStatusName : "Unassigned";
        if (milestoneStatus && milestoneStatus.length > 0 && !milestoneStatus.includes(statusName)) return false;
        // IsStartupEssential filter
        if (isStartupEssential && isStartupEssential.length > 0) {
            const boolStartupEssential = isStartupEssential.map((v: string) => v === "Yes" ? true : v === "No" ? false : v);
            if (!boolStartupEssential.includes(this.IsStartupEssential)) return false;
        }
        // IsChecklistItem filter
        if (isChecklistItem && isChecklistItem.length > 0) {
            const boolChecklistItem = isChecklistItem.map((v: string) => v === "Yes" ? true : v === "No" ? false : v);
            if (!boolChecklistItem.includes(this.IsChecklistItem)) return false;
        }
        // ShowOnPortal filter
        if (showOnPortal && showOnPortal.length > 0) {
            const boolShowOnPortal = showOnPortal.map((v: string) => v === "Yes" ? true : v === "No" ? false : v);
            if (!boolShowOnPortal.includes(this.ShowOnPortal)) return false;
        }
        return true;
    }
}

export class MilestoneStatusListingDto {
    Id: number;
    Name: string;
    SortById: number;

    constructor() { }

}